import request from '@/utils/request'
import qs from 'qs'

// 获取列表
export function getAccountList(data: any) {
  return request({
    url: '/author/authorList',
    method: 'get',
    params: data
  })
}

// 新增用户
interface IAccount {
  account: string
  uid: string | number
  ladpAccount?: string
  group?: string
}
export function addAccount(data: IAccount) {
  return request({
    url: '/author/addAuthor',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 编辑用户
export function updateAccount(data: IAccount) {
  return request({
    url: '/author/editAuthor',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除用户
export function deleteAccount(data: { uid: string | number }) {
  return request({
    url: '/author/delAuthor',
    method: 'post',
    data: qs.stringify(data)
  })
}
